import { Button, Col, Row, Table } from "react-bootstrap";
import "../../../assets/scss/DataGrid.scss";
import { Link } from "react-router-dom";

import { IDwelling } from "../reducers";
import DwellingDataGridBadgeComponent from "./DwellingDataGridBadgeComponent";
import { getServiceOrderTypeValuesByType } from "../../../_constants/serviceOrder.ts";
import {
  displayMinName,
  getDateFromIso,
  getValue,
} from "../../../_helpers/stringHelper";
import { pagination } from "../../../_helpers/tableHelper";
import ColoredMarker from "../../../common/components/ColoredMarker";
import GridActionButtons from "../../../common/components/GridActionButtons";
import Loader from "../../../common/components/Loader";
import PaginationComponent from "../../../common/components/PaginationComponent";
import SearchBarre from "../../../common/components/searchBarre/SearchBarre";
import Status from "../../../common/components/StatusComponent";
import { GridType } from "../../../common/enums/sharedEnums.ts";
import { ITenant } from "../../serviceOrdering/reducers";
import { DWELLING_DETAILS, NEW_DWELLING, UPDATE_DWELLING } from "../routes";

export interface DwellingDataGridComponentProps {
  dwellings: IDwelling[];
  states?: any;
  noMenu?: any; //add to remove the search and import tools
  activePage: number;
  setActivePage: React.Dispatch<React.SetStateAction<number>>;
  dwellingsNb: number;
  loading: boolean;
}

const DwellingDataGridComponent: React.FC<DwellingDataGridComponentProps> = ({
  dwellings,
  states,
  noMenu,
  activePage,
  setActivePage,
  dwellingsNb,
  loading,
}) => {
  const lastAction = (item: IDwelling) => {
    return item?.lastService?.type
      ? getServiceOrderTypeValuesByType(item?.lastService?.type as keyof object)
          ?.labelMin
      : "Aucune";
  };

  return (
    <div className="d-flex flex-column gap-3">
      {noMenu !== true && states !== undefined && (
        <Row className=" align-items-center">
          <Col lg={7} className="align-items-center d-flex">
            <SearchBarre
              disabled={loading}
              setSearchValue={(value) => {
                setActivePage(1);
                states.setInputFilter(value);
              }}
              placeholder="Rechercher le bien par adresse, bailleur ou nom de l’ancien occupant..."
            />
          </Col>
          <Col lg={{ span: 3, offset: 2 }} className=" align-items-center">
            <div className="d-flex justify-content-lg-end flex-grow-1 gap-3">
              {/*NOT FOR THE MVP*/}
              {/*<Button*/}
              {/*  className="archive-btn d-flex align-items-center justify-content-center w-100 flex-grow-1"*/}
              {/*  variant="outline-primary"*/}
              {/*>*/}
              {/*  <i style={{ fontSize: '18px' }} className="bi bi-upload me-3 me-lg-2"></i>*/}
              {/*  Importer mes biens*/}
              {/*</Button>*/}
              <Link to={NEW_DWELLING}>
                <Button type="button" variant="success" className="btn-add-new">
                  <i className="bi bi-plus" />
                  Ajouter un bien
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      )}

      <div className="datagridTable p-2">
        <Table borderless responsive className="datagridTable">
          <thead>
            <tr className="orders-gird-header">
              <th>Agence</th>
              <th>Adresse</th>
              <th>N° lot de gestion</th>
              <th>Bailleur</th>
              <th>Loc. sortant</th>
              <th>Loc. entrant</th>
              <th>Dernière action</th>
              <th>DPE</th>
              <th>Diagnostics</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="property-data-grid mt-3">
            {loading ? (
              <tr>
                <td colSpan={8}>
                  <Loader />
                </td>
              </tr>
            ) : dwellings && dwellings.length > 0 ? (
              <>
                {dwellings.map((dwelling, index) => (
                  <tr className="datagrid-fields" key={index}>
                    <td>{dwelling.agency.label}</td>
                    <td>
                      <DwellingDataGridBadgeComponent dwelling={dwelling} />
                    </td>
                    <td className="text-center">
                      {dwelling.managementLotNumber}
                    </td>
                    <td className="text-center">{getValue(dwelling.lessor)}</td>
                    <td className="text-center">
                      {dwelling?.outgoingTenants?.map(
                        (tenant: ITenant, index: number) => {
                          return (
                            <div key={index}>
                              <div className="fw-bold">
                                {displayMinName(
                                  tenant.person.lastname,
                                  tenant.person.firstname,
                                )}
                              </div>
                              <div>{getDateFromIso(tenant.rentalEndDate)}</div>
                            </div>
                          );
                        },
                      )}
                    </td>
                    <td className="text-center">
                      {dwelling?.incomingTenants?.map(
                        (tenant: ITenant, index: number) => {
                          return (
                            <div key={index}>
                              <div className="fw-bold">
                                {displayMinName(
                                  tenant.person.lastname,
                                  tenant.person.firstname,
                                )}
                              </div>
                              <div>
                                {getDateFromIso(tenant.rentalStartDate)}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </td>
                    <td>
                      <Status
                        className="mx-auto"
                        currentStatus={lastAction(dwelling)}
                      />
                    </td>
                    <td>
                      {/*{item.energy_performance && item.greenhouse_gas*/}
                      {/*    ? <NewDPE className="mx-auto" params={{*/}
                      {/*        dpe: item.energy_performance,*/}
                      {/*        ges: item.greenhouse_gas*/}
                      {/*    }}/>*/}
                      {/*    : ? */}
                      <ColoredMarker className="mx-auto" color="#000D5B55">
                        X
                      </ColoredMarker>
                    </td>
                    <td>
                      {/*{item.diagsComplete === true ?*/}
                      {/*    <ColoredMarker className="mx-auto" color="#11BFA4"> Ok </ColoredMarker>*/}
                      {/*    :*/}
                      <ColoredMarker className="mx-auto" color="#EF3826">
                        À refaire
                      </ColoredMarker>
                      {/*}*/}
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <GridActionButtons
                          viewUrl={DWELLING_DETAILS.replace(
                            ":id",
                            dwelling.datedReference || dwelling.id || "",
                          )}
                          editUrl={UPDATE_DWELLING.replace(
                            ":id",
                            dwelling.datedReference || dwelling.id || "",
                          ).replace(":isAssociatingBuilding", "false")}
                          downloadablePath={dwelling?.mainFile?.path}
                          type={GridType.dwelling}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <>
                <p className="p-no-property mt-3 ms-2">
                  Aucun bien disponible.
                </p>
              </>
            )}
          </tbody>
        </Table>
      </div>

      {dwellings && dwellings.length > 0 && (
        <div className="navigationButtonWrapper">
          <PaginationComponent
            pages={pagination(dwellingsNb)}
            activePage={activePage}
            setActivePage={setActivePage}
            disabled={loading}
          />
        </div>
      )}
    </div>
  );
};

export default DwellingDataGridComponent;
